'use client';

import type { Transition } from 'motion/react';
import { motion, useAnimation } from 'motion/react';
import { useEffect } from 'react';

import { cn } from '@/lib/utils';

type ChevronsUpDownIconProps = {
  className?: string;
  size?: number;
  isAnimating?: boolean;
};

const defaultTransition: Transition = {
  type: 'spring',
  stiffness: 250,
  damping: 25,
};

const ChevronsUpDownIcon = ({
  className,
  size = 16,
  isAnimating,
}: ChevronsUpDownIconProps) => {
  const controls = useAnimation();

  useEffect(() => {
    if (isAnimating) {
      controls.start('animate');
    } else {
      controls.start('normal');
    }
  }, [isAnimating, controls]);

  return (
    <svg
      aria-label='Chevrons Up Down Icon'
      className={cn(className)}
      fill='none'
      height={size}
      role='img'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <motion.path
        animate={controls}
        d='m7 15 5 5 5-5'
        initial='normal'
        transition={defaultTransition}
        variants={{
          normal: { translateY: '0%' },
          animate: { translateY: '2px' },
        }}
      />
      <motion.path
        animate={controls}
        d='m7 9 5-5 5 5'
        initial='normal'
        transition={defaultTransition}
        variants={{
          normal: { translateY: '0%' },
          animate: { translateY: '-2px' },
        }}
      />
    </svg>
  );
};

ChevronsUpDownIcon.displayName = 'ChevronsUpDownIcon';

export { ChevronsUpDownIcon };
